/* eslint-disable no-unused-vars */

import { Table, Tag, Pagination } from 'antd';
import { useEffect, useState } from 'react';
import { EditOutlined } from '@ant-design/icons';
import { get } from 'lodash-es';
import { Link } from 'react-router-dom';
import PageSizer from 'components/Common/PageSizer';
import { map } from 'lodash';
import SearchBox from 'components/Common/SearchBox';

export default function CorporateUsersList({
  corporateId,
  data,
  isAdmin = false,
  setEditCorporateUserObject,
  setAddCorporateUserOpen,
  isLoading,
  setQuery,
  currentPageNo,
  pageSize,
  setCurrentPageNo,
  setPageSize,
}) {
  const [usersData, setUsersData] = useState([]);
  const [currentPage, setCurrentPage] = useState(currentPageNo);
  const [pageLimit, setPageLimit] = useState(pageSize);

  useEffect(() => {
    let usrdata = [];
    usrdata = data?.data;
    setUsersData(usrdata);
  }, [data, isAdmin]);

  const onClickEditIcon = (user) => {
    setEditCorporateUserObject(user);
    setAddCorporateUserOpen(true);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'NAME',
      key: 'x',
      width: 200,
      render: (text, user) => <>{user?.NAME}</>,
    },
    {
      title: 'Email',
      dataIndex: 'EMAIL',
      render: (text, user) => (
        <>
          <Link
            to={`/corporate/users/session/${user?.ID}/${user?.EMAIL}/${user?.PHONE_NUMBER}`}
          >
            {user?.EMAIL}
          </Link>
        </>
      ),
      key: 'EMAIL',
      width: 200,
    },
    {
      title: 'Phone',
      dataIndex: 'PHONE_NUMBER',
      render: (name, user) => <>{user?.PHONE_NUMBER}</>,
      key: 'PHONE_NUMBER',
      width: 200,
    },
    {
      title: 'Group',
      dataIndex: 'NAME',
      render: (name, user) => <>{get(user, 'JP_CORPORATE_LOCATION.NAME')}</>,
      key: 'NAME',
      width: 260,
    },
    {
      title: 'Status',
      dataIndex: 'IS_ACTIVE',
      render: (name, user) => (
        <Tag
          color={get(user, 'JP_CORPORATE_USERS.IS_ACTIVE') ? 'green' : 'orange'}
        >
          {get(user, 'JP_CORPORATE_USERS.IS_ACTIVE') ? 'Active' : 'Inactive'}
        </Tag>
      ),
      key: 'IS_ACTIVE',
      width: 100,
    },
    {
      title: 'Actions',
      dataIndex: '',
      render: (name, user) => (
        <>
          <EditOutlined
            onClick={() => {
              onClickEditIcon(user);
            }}
            style={{ cursor: 'pointer' }}
          />
        </>
      ),
      key: '',
      width: 260,
    },
  ];

  function makeData(usersData) {
    const users = usersData?.slice(
      (currentPage - 1) * pageLimit,
      currentPage * pageLimit,
    );

    const formattedUsers = map(users, (user, s) => {
      return {
        ...user,
        key: s,
      };
    });

    return formattedUsers;
  }

  function onPageSizeChange(newPageSize) {
    setPageSize(newPageSize);
    setPageLimit(newPageSize);
  }

  function onSearch(queryStr) {
    if (queryStr) setQuery(queryStr?.trim());
    else setQuery('');
    setCurrentPage(1);
  }

  function getTitle() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: 0,
        }}
      >
        <SearchBox
          onSearch={(qry) => {
            onSearch(qry);
          }}
          width={500}
          placeholder="Search by Name,Email,Phone"
        />
      </div>
    );
  }

  function getFooter() {
    return (
      <div
        style={{
          float: 'right',
          display: 'flex',
          justifyContent: 'flex-end',
          margin: 0,
        }}
      >
        <div style={{ marginTop: 5 }}>
          Total {usersData?.length ? data?.count : 0} records
        </div>
        <Pagination
          current={currentPageNo}
          defaultCurrent={1}
          pageSize={pageLimit}
          total={data?.count}
          onChange={(pageSize) => {
            setCurrentPageNo(pageSize);
          }}
        />
        <PageSizer
          onChangeHandler={(newPageSize) => {
            onPageSizeChange(newPageSize);
          }}
          selectedPageSize={pageLimit}
        />
      </div>
    );
  }

  return (
    <>
      {
        <Table
          columns={columns}
          dataSource={makeData(usersData)}
          // rowKey="PHONE_NUMBER"
          loading={isLoading}
          pagination={false}
          title={() => getTitle()}
          footer={() => getFooter()}
        />
      }
    </>
  );
}
